import React from 'react';
import ReactGA from 'react-ga4';

const Content = () => {
  return (
    <>
      <div className="popup-content-title">
        <h3>Longwarry - Watermain Renewal and Upgrade Stage 2 (Renewal alignment)</h3>
      </div>
      <div className="popup-content-source">
        <p>
          <span className="bold">
          We’re planning to upgrade the water main along Nar Nar Goon-Longwarry Rd and install a new water main along Cook Road, Longwarry. 
          </span>
        </p>
        <p>
        We’ve awarded the construction of the water main renewal to our Our Industry Partner Beca, Fulton Hogan, Interflow Joint Venture (BFHI JV) plan to start construction mid October on Stage 1 with stage 2 anticipated to start early 2027. 
        We expect construction to take approximately 12 months for both sets of work (depending on the weather and ground conditions).
        </p>
        <p>
          For more information visit{' '}
          <a
            href="https://southeastwater.com.au/longwarrywmrenewal"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: `Map – Water Renewals (blue)`,
                action: '<a href> link',
                label: 'MORE INFO: Longwarry water main renewal and upgrade',
              });
            }}
          >
            Longwarry water main renewal and upgrade
            | South East Water
          </a>{' '}
          email{' '}
          <a
            href="mailto:engagement@sew.com.au"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: `Map - Water Renewals (blue)`,
                action: 'Email link',
                label:
                  'MAIL TO: engagement@sew.com.au: Longwarry water main renewal and upgrade',
              });
            }}
          >
            engagement@sew.com.au
          </a>{' '}
          or call <a href="tel:1800403777">1800 403 777</a> |{' '}
        </p>
      </div>
    </>
  );
};

export default Content;
